import styled from 'styled-components';

export const LinkedlistItems= styled.div`
  position: absolute;
  top: 100%;
  right: 25px;
  box-shadow: 0 20px 50px 0 rgba(0,0,0,0.2);
  background-color: white;
  width: 180px;

  > a {
    + a {
      border-top: 1px solid #E7EBEC;
      display: block;
    }
  }
`;
export const LinkedlistItem= styled.div`
  width: 100%;
  color: #183748;
  font-size: 10px;
  font-weight: 600;
  letter-spacing: 2px;
  line-height: 14px;
  text-align: center;
  padding: 13px 0px;
  text-transform: uppercase;

  &.danger {
    color: #FF3D00;
  }

  &:hover {
    background-color: #f1f1f1;
  }
`;
